import { SMILE9_API_ENDPOINT } from './../../../environments/environment';
import { NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SKS_MASTER_API_ENDPOINT } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { UtilService } from '../util/util.service';
import { LogIf } from './log-if';

@Injectable()
export class LogService {
  navigationEnd: NavigationEnd;

  constructor(
    private http: HttpClient,
    private utilServ: UtilService,
  ) { }

  /**
   * サインインログをDBへ出力
   * @param signinResult ok: サインイン成功ログとして出力, ng: サインイン失敗ログとして出力
   * @param username フォームに入力されたユーザー名
   * @param password フォームに入力されたパスワード
   */
  public async sendSigninLogAsync(signinResult: string, username?: string, password?: string) {
    let pageName = '';
    switch (location.pathname) {
      case '/signin':
        pageName = '通常サインイン';
        break;
      case '/demo-signin':
        pageName = 'デモサインイン';
        break;
      case '/card-signin':
        pageName = 'カードサインイン';
        break;
      case '/fsc-signin':
        pageName = '給食Cサインイン';
        break;
    }

    if (signinResult === 'ok') {
      const httpBody: LogIf.PostSigninOkLog = {
        page_name: pageName
      };
      await this.sendSigninOkLogAsync(httpBody);
    }
    if (signinResult === 'ng') {
      const httpBody: LogIf.PostSigninNgLog = {
        username: username,
        password: password,
        page_name: pageName
      };
      await this.sendSigninNgLogAsync(httpBody);
    }
    return true;
  }

  /** サーバエラーログ出力 */
  public sendServerErrorLog(log: LogIf.PostServerErrorLogs) {
    return this.http.request('post',
        `${SKS_MASTER_API_ENDPOINT}api/ErrorLog`,
        { body: log }
   );
  }

  /** 成功サインインログの出力 */
  sendSigninOkLogAsync(log: LogIf.PostSigninOkLog) {
    return new Promise(resolve => {
      this.http.request('post',
      `${SMILE9_API_ENDPOINT}api/SignInLog/SignOk`,
      { body: log }
      ).subscribe(
        res => {
          resolve();
        },
        error => {
          resolve();
        }
      );
    });
  }

  /** 失敗サインインログの出力 */
  sendSigninNgLogAsync(log: LogIf.PostSigninNgLog) {
    return new Promise(resolve => {
      this.http.request('post',
      `${SMILE9_API_ENDPOINT}api/SignInLog/SignNg`,
      { body: log }
      ).subscribe(
        res => {
          resolve();
        },
        error => {
          resolve();
        }
      );
    });
  }
}
